<mat-drawer-container style="height:100%">
  <mat-drawer-content>

    <div style="place-content: stretch center; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex; height:100%">
      <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch flex-start; align-items: stretch; flex: 1 1 100%; max-width: 50%;">
        <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 8%">
        </div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; margin: 25px;">

          <mat-toolbar color="primary" class="toolbar-over-card" style="padding: 20px; z-index: 1;">Admin Download</mat-toolbar>

          <mat-card appearance="outlined" class="card-under-toolbar" style="z-index: auto;">
            <mat-card-content>
              <mat-form-field style="width: 265px;">
                <mat-label>Document Id</mat-label>
                <input #tbDocId matInput autofocus (paste)="onPaste($event)">
              </mat-form-field>

              <button mat-button color="primary" (click)="getDocInfo(tbDocId.value)">GET</button>

              <div *ngIf="docDetails" style="place-content: stretch flex-start; align-items: stretch; flex-flow: row wrap; box-sizing: border-box; display: flex;">
                <ng-container *ngFor="let detail of docDetails">
                  <div style="flex: 0 1 calc(50% - 32px); box-sizing: border-box;" class="doc-detail-cell">
                    <div class="doc-detail-title">{{detail.title}}</div>
                    <div>{{detail.value}}</div>
                  </div>
                </ng-container>
              </div>
              <button mat-button color="primary" [disabled]="!docFiles || docFiles.length === 0 || noFilesChecked()" (click)="postFileList()" style="margin-top: 16px;">DOWNLOAD SELECTED</button>
            </mat-card-content>

            <mat-table #table [dataSource]="docFilesDataSource">

              <ng-container matColumnDef="selectFile">
                <mat-header-cell *matHeaderCellDef>
                  <mat-form-field appearance="outline" class="show-no-errors density-neg-3 custom-infix-padding" style="height: 40px; margin-top: -12px;">
                    <mat-label style="font-size: 12px;">Select</mat-label>
                    <mat-select>
                      <mat-option (click)="checkAll(true)">All</mat-option>
                      <mat-option (click)="checkLifecycle(0)">Active</mat-option>
                      <mat-option (click)="checkLifecycle(1)">Deleted</mat-option>
                      <mat-option (click)="checkOriginals()">Originals</mat-option>
                      <mat-option (click)="checkAll(false)">None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index;">
                  <mat-checkbox [(ngModel)]="checkedFileIndices[i]"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- ID Column -->
              <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef> File ID </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.fileId}} </mat-cell>
              </ng-container>

              <!-- Type Column -->
              <ng-container matColumnDef="fileType">
                <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{FileType[element.fileType]}} </mat-cell>
              </ng-container>

              <!-- Lifecycle Column -->
              <ng-container matColumnDef="lifecycle">
                <mat-header-cell *matHeaderCellDef> Lifecycle </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.lifecycle === 0 ? 'Active' : 'Deleted'}} </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="fileInfoDisplayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: fileInfoDisplayedColumns;"></mat-row>
            </mat-table>
          </mat-card>

        </div>
        <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 8%">
        </div>
      </div>
    </div>

  </mat-drawer-content>
</mat-drawer-container>
